module.exports = __webpack_public_path__ + "img/18.6aef7974.png";